/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DocumentTaxFormType {
    UNKNOWN = 'Unknown',
    IRS1099R = 'IRS1099R',
    IRS5498 = 'IRS5498',
    IRS1099Q = 'IRS1099Q',
}
